import { render, staticRenderFns } from "./ModalReorder.vue?vue&type=template&id=1936531e&"
import script from "./ModalReorder.vue?vue&type=script&lang=js&"
export * from "./ModalReorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports